import {Provider} from "react-redux";
import shopStore from "../stores/shopStore.ts";
import {ChildrenPropsTypes} from "../helpers/childrenProps.types.ts";

export const GlobalProvider = ({children}: ChildrenPropsTypes) => {
    return (
        <Provider store={shopStore}>
            {children}
        </Provider>
    );
};
